import { render, staticRenderFns } from "./address-card.vue?vue&type=template&id=aaf033ac&"
import script from "./address-card.vue?vue&type=script&lang=js&"
export * from "./address-card.vue?vue&type=script&lang=js&"
import style0 from "./address-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaf033ac')) {
      api.createRecord('aaf033ac', component.options)
    } else {
      api.reload('aaf033ac', component.options)
    }
    module.hot.accept("./address-card.vue?vue&type=template&id=aaf033ac&", function () {
      api.rerender('aaf033ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/address-card.vue"
export default component.exports